import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import { requestRecalculateCompleteness } from '../../completeness'
import { selectFinancialYear, selectPartnerId, selectProgramType } from '../../configuration'
import { requestCommitmentItems } from '../api/requestCommitmentItems'
import { requestCommitmentStatuses } from '../api/requestCommitmentStatuses'

/**
 * Automatically refreshes commitment statuses and items when completeness is recalculated.
 *
 * This listener listens to requestRecalculateCompleteness.fulfilled and triggers
 * a refresh of commitment data to ensure the UI stays in sync after completeness changes.
 * This eliminates the need for each caller to manually dispatch requestCommitmentStatuses.
 */
listenerMiddleware.startListening({
  actionCreator: requestRecalculateCompleteness.fulfilled,
  effect: (action, { getState, dispatch }) => {
    const state = getState()
    const partnerId = selectPartnerId(state)
    const fYear = selectFinancialYear(state)
    const programType = selectProgramType(state)

    dispatch(
      requestCommitmentItems({
        partnerId,
        programType,
        fYear,
      })
    )

    dispatch(
      requestCommitmentStatuses({
        partnerId,
        fYear,
      })
    )
  },
})
